function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-52 -49.4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M151.952,103.191h12.995V49.4H151.952ZM129.136,87.855a3.515,3.515,0,0,1-3.475,3.475h-7.555a3.515,3.515,0,0,1-3.475-3.475V66.172H101.636v22.74c0,9.293,5.968,14.2,14.732,14.2H129.06c8.084,0,12.994-5.817,12.994-14.2V66.172H129.06C129.136,66.172,129.136,87.175,129.136,87.855Zm73.056-21.683V87.855a3.515,3.515,0,0,1-3.475,3.475h-7.555a3.515,3.515,0,0,1-3.475-3.475V66.172H174.692v22.74c0,9.293,5.968,14.2,14.732,14.2h12.692c8.084,0,12.994-5.817,12.994-14.2V66.172Zm-124.505,0h-8.31a10.159,10.159,0,0,0-4.382.756V49.4H52v53.716H64.919V81.508a3.515,3.515,0,0,1,3.475-3.475h7.555a3.515,3.515,0,0,1,3.475,3.475v21.683H92.419V79.771C92.419,69.949,85.846,66.172,77.687,66.172Z",
  fill: "#181923"
}));

var SvgHuluDark = function SvgHuluDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163.111,
    height: 53.791,
    viewBox: "0 0 163.111 53.791",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHuluDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hulu-dark.05254d62.svg";
export { ForwardRef as ReactComponent };